import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import {HelpQuestionMarkModule} from '../help-question-mark/index';

import { FilterComponent } from './filter.component';

import { 
  InputModule } from '@components/form-group/index';

@NgModule({
  declarations: [FilterComponent],
  imports: [
    CommonModule,
    InputModule,
    ReactiveFormsModule,
    HelpQuestionMarkModule,
  ],
  exports: [FilterComponent]
})
export class FilterModule { }
